import { PLPQueryData, usePLPQuery } from 'client/api/plp-results';
import { ChipList } from 'client/pages/Facet/ChipList/ChipList';
import FacetItem from 'client/pages/Facet/FacetItem/FacetItem';
import FacetItemCategory from 'client/pages/Facet/FacetItemCategory/FacetItemCategory';
import { useMainState } from 'client/state/Main';
import React, { useCallback } from 'react';

interface FacetItemListProps {
  isDrawerView?: boolean;
}

function FacetItemList({ isDrawerView = false }: FacetItemListProps) {
  const plpurl = useMainState((s) => s.plpURL);
  const { data } = usePLPQuery(
    useCallback(
      (d: PLPQueryData) => ({
        facets: d.facets,
        categories: d.categories,
      }),
      [],
    ),
  );

  return (
    <>
      <ChipList />

      {data?.categories?.map((c) => (
        <FacetItemCategory key={c.name} id={c.id} name={c.name} values={c.values} isDrawerView={isDrawerView} />
      ))}
      {data?.facets
        ?.filter(({ id }) => id !== plpurl.unfilteredFacet)
        .map(({ id, name, values }) => (
          <FacetItem key={`${id}_${name}`} id={id} name={name} isDrawerView={isDrawerView} values={values} />
        ))}
    </>
  );
}

export default React.memo(FacetItemList);
